import React, { useState, useEffect } from 'react';
import { ChevronRight, ChevronLeft, Play, X, Image, BookOpen } from 'lucide-react';

const PresentationSlides = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [showVideo, setShowVideo] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  const [animating, setAnimating] = useState(false);
  const [language, setLanguage] = useState('fr');

  const galleryImages = [
    { id: 1, title: "Page d'accueil", desc: "Design moderne", src: "/images/screenshot1.jpg" },
    { id: 2, title: "Liste Professeurs", desc: "Profils détaillés", src: "/images/screenshot2.jpg" },
    { id: 3, title: "Filtres", desc: "Recherche facile", src: "/images/screenshot3.jpg" },
    { id: 4, title: "Formulaire", desc: "Demande simple", src: "/images/screenshot4.jpg" },
    { id: 5, title: "Admin", desc: "Gestion", src: "/images/screenshot5.jpg" },
    { id: 6, title: "Mobile", desc: "Responsive", src: "/images/screenshot6.jpg" }
  ];

  const slides = [
    {
      id: 0,
      title: { fr: "ÉLITE TUTORAT", ar: "النخبة للدروس الخصوصية" },
      subtitle: { fr: "Ma Plateforme de Cours Particuliers", ar: "منصتي للدروس الخصوصية" },
      description: { fr: "Un projet pour aider les parents à trouver facilement des professeurs à Casablanca", ar: "مشروع لمساعدة الآباء على إيجاد المدرسين بسهولة في الدار البيضاء" },
      gradient: "from-indigo-600 via-purple-600 to-indigo-800",
      icon: "🎓",
      showLogo: true
    },
    {
      id: 1,
      title: { fr: "Le Problème", ar: "المشكلة" },
      subtitle: { fr: "Trouver un prof, c'est dur !", ar: "إيجاد أستاذ صعب!" },
      content: {
        fr: [
          "📱 WhatsApp et bouche-à-oreille",
          "❌ Prix pas clairs",
          "❓ Qualité inconnue",
          "⏰ Pas de disponibilité",
          "😓 Beaucoup de temps perdu"
        ],
        ar: [
          "📱 واتساب والحديث الشفهي",
          "❌ أسعار غير واضحة",
          "❓ جودة غير معروفة",
          "⏰ لا توجد معلومات عن التوفر",
          "😓 الكثير من الوقت الضائع"
        ]
      },
      gradient: "from-red-600 via-orange-600 to-red-800",
      icon: "⚠️"
    },
    {
      id: 2,
      title: { fr: "Ma Solution", ar: "حلي" },
      subtitle: { fr: "Tout est simple et clair", ar: "كل شيء بسيط وواضح" },
      content: {
        fr: [
          "📸 Photo + CV du prof",
          "📝 Son expérience visible",
          "🎯 Matières qu'il enseigne",
          "🏙️ Villes disponibles (Casa)",
          "💰 Prix affiché direct"
        ],
        ar: [
          "📸 صورة + سيرة ذاتية للأستاذ",
          "📝 خبرته مرئية",
          "🎯 المواد التي يدرسها",
          "🏙️ المدن المتاحة (الدار البيضاء)",
          "💰 السعر معروض مباشرة"
        ]
      },
      gradient: "from-green-600 via-emerald-600 to-green-800",
      icon: "💡"
    },
    {
      id: 3,
      title: { fr: "Comment Ça Marche ?", ar: "كيف يعمل؟" },
      subtitle: { fr: "Super facile en 4 étapes", ar: "سهل جداً في 4 خطوات" },
      content: {
        fr: [
          "1️⃣ Tu choisis un prof qui te plaît",
          "2️⃣ Tu remplis un petit formulaire",
          "3️⃣ L'admin vérifie et valide",
          "4️⃣ Tu reçois la confirmation",
          "✅ Pas besoin de créer un compte !"
        ],
        ar: [
          "1️⃣ تختار أستاذاً يعجبك",
          "2️⃣ تملأ استمارة صغيرة",
          "3️⃣ المشرف يتحقق ويوافق",
          "4️⃣ تتلقى التأكيد",
          "✅ لا حاجة لإنشاء حساب!"
        ]
      },
      gradient: "from-blue-600 via-cyan-600 to-blue-800",
      icon: "⚙️"
    },
    {
      id: 4,
      title: { fr: "C'est Pour Qui ?", ar: "لمن هو؟" },
      subtitle: { fr: "Qui utilise la plateforme ?", ar: "من يستخدم المنصة؟" },
      content: {
        fr: [
          "👨‍👩‍👧 Parents qui cherchent un prof",
          "🎓 Élèves du collège et lycée",
          "📚 Étudiants à l'université",
          "👨‍🏫 Profs sérieux et qualifiés"
        ],
        ar: [
          "👨‍👩‍👧 الآباء الذين يبحثون عن أستاذ",
          "🎓 تلاميذ الإعدادية والثانوية",
          "📚 طلاب الجامعة",
          "👨‍🏫 أساتذة جادون ومؤهلون"
        ]
      },
      gradient: "from-purple-600 via-pink-600 to-purple-800",
      icon: "🎯"
    },
    {
      id: 5,
      title: { fr: "Modèle Économique", ar: "النموذج الاقتصادي" },
      subtitle: { fr: "Comment gagner de l'argent ?", ar: "كيف نكسب المال؟" },
      content: {
        fr: [
          "🎯 Au début : Tester l'idée et créer la confiance",
          "❌ Pas de recherche de profit immédiat",
          "💰 Plus tard : Petite commission par cours",
          "📅 Ou : Abonnement mensuel pour les professeurs",
          "📢 Publicités pour d'autres services (livres, apps...)",
          "📦 Packs premium : profil mis en avant + badge",
          "✅ Croissance progressive et durable"
        ],
        ar: [
          "🎯 في البداية: اختبار الفكرة وبناء الثقة",
          "❌ لا نبحث عن الربح الفوري",
          "💰 لاحقاً: عمولة صغيرة لكل درس",
          "📅 أو: اشتراك شهري للأساتذة",
          "📢 إعلانات لخدمات أخرى (كتب، تطبيقات...)",
          "📦 باقات مميزة: ملف مميز + شارة",
          "✅ نمو تدريجي ومستدام"
        ]
      },
      gradient: "from-yellow-600 via-amber-600 to-yellow-800",
      icon: "💰"
    },
    {
      id: 6,
      title: { fr: "Le Budget", ar: "الميزانية" },
      subtitle: { fr: "Combien ça coûte ?", ar: "كم تكلف؟" },
      content: {
        fr: [
          "🌐 Hébergement site : 50-100 DH/mois",
          "📍 Nom de domaine : 100 DH/an",
          "📱 Pub Facebook/Insta : 200-500 DH/mois",
          "✅ TOTAL : Moins de 2000 DH",
          "💪 C'est accessible !"
        ],
        ar: [
          "🌐 استضافة الموقع: 50-100 درهم/شهر",
          "📍 اسم النطاق: 100 درهم/سنة",
          "📱 إعلانات فيسبوك/إنستغرام: 200-500 درهم/شهر",
          "✅ المجموع: أقل من 2000 درهم",
          "💪 إنه في المتناول!"
        ]
      },
      gradient: "from-green-600 via-teal-600 to-green-800",
      icon: "💵"
    },
    {
      id: 7,
      title: { fr: "La Vidéo", ar: "الفيديو" },
      subtitle: { fr: "Regarde comment ça marche", ar: "شاهد كيف يعمل" },
      gradient: "from-teal-600 via-cyan-600 to-teal-800",
      icon: "🎬",
      isVideo: true
    },
    {
      id: 8,
      title: { fr: "Photos du Site", ar: "صور الموقع" },
      subtitle: { fr: "Voilà à quoi ça ressemble", ar: "هكذا يبدو" },
      gradient: "from-rose-600 via-pink-600 to-rose-800",
      icon: "🖼️",
      isGallery: true
    },
    {
      id: 9,
      title: { fr: "Les Risques", ar: "المخاطر" },
      subtitle: { fr: "Je suis honnête", ar: "أنا صادق" },
      content: {
        fr: [
          "⚠️ Au début : Peu de confiance",
          "⚠️ Il y a de la concurrence",
          "✅ MAIS : Projet local Casa",
          "✅ MAIS : Vrai besoin réel",
          "💪 Je suis motivé !"
        ],
        ar: [
          "⚠️ في البداية: ثقة قليلة",
          "⚠️ هناك منافسة",
          "✅ لكن: مشروع محلي في الدار البيضاء",
          "✅ لكن: حاجة حقيقية فعلية",
          "💪 أنا متحمس!"
        ]
      },
      gradient: "from-orange-600 via-red-600 to-orange-800",
      icon: "⚖️"
    },
    {
      id: 10,
      title: { fr: "Pourquoi Ce Projet ?", ar: "لماذا هذا المشروع؟" },
      subtitle: { fr: "Ma motivation personnelle", ar: "دوافعي الشخصية" },
      content: {
        fr: [
          "✨ Résoudre un vrai problème",
          "💻 Apprendre à coder",
          "📊 Comprendre le business",
          "🎯 Aider les gens autour de moi",
          "🚀 Ma première expérience !"
        ],
        ar: [
          "✨ حل مشكلة حقيقية",
          "💻 تعلم البرمجة",
          "📊 فهم الأعمال التجارية",
          "🎯 مساعدة الناس من حولي",
          "🚀 تجربتي الأولى!"
        ]
      },
      gradient: "from-indigo-600 via-blue-600 to-indigo-800",
      icon: "🎉"
    },
    {
      id: 11,
      title: { fr: "Merci !", ar: "شكراً!" },
      subtitle: { fr: "Des questions ?", ar: "أسئلة؟" },
      gradient: "from-green-600 via-emerald-600 to-green-800",
      icon: "🙏",
      showThankYou: true
    }
  ];

  const nextSlide = () => {
    if (currentSlide < slides.length - 1) {
      setAnimating(true);
      setTimeout(() => {
        setCurrentSlide(currentSlide + 1);
        setAnimating(false);
      }, 300);
    }
  };

  const prevSlide = () => {
    if (currentSlide > 0) {
      setAnimating(true);
      setTimeout(() => {
        setCurrentSlide(currentSlide - 1);
        setAnimating(false);
      }, 300);
    }
  };

  const goToSlide = (index) => {
    setAnimating(true);
    setTimeout(() => {
      setCurrentSlide(index);
      setAnimating(false);
    }, 300);
  };

  useEffect(() => {
    const handleKeyPress = (e) => {
      if (e.key === 'ArrowRight') nextSlide();
      if (e.key === 'ArrowLeft') prevSlide();
      if (e.key === 'Escape') {
        setShowVideo(false);
        setSelectedImage(null);
      }
    };
    window.addEventListener('keydown', handleKeyPress);
    return () => window.removeEventListener('keydown', handleKeyPress);
  }, [currentSlide]);

  const slide = slides[currentSlide];
  const isRTL = language === 'ar';

  const getText = (field) => {
    if (typeof field === 'string') return field;
    if (typeof field === 'object' && field !== null) return field[language] || field.fr;
    return '';
  };

  const getContent = (content) => {
    if (!content) return null;
    if (Array.isArray(content)) return content;
    return content[language] || content.fr || [];
  };

  return (
    <div className="fixed inset-0 w-full h-full overflow-hidden bg-gray-900 z-50" dir={isRTL ? 'rtl' : 'ltr'}>
      <div className={`absolute inset-0 bg-gradient-to-br ${slide.gradient} transition-all duration-700 ${animating ? 'opacity-0 scale-95' : 'opacity-100 scale-100'}`}>
        <div className="absolute inset-0 opacity-20">
          <div className="absolute top-0 right-0 w-64 md:w-96 h-64 md:h-96 bg-white rounded-full mix-blend-overlay filter blur-3xl animate-pulse"></div>
          <div className="absolute bottom-0 left-0 w-64 md:w-96 h-64 md:h-96 bg-purple-300 rounded-full mix-blend-overlay filter blur-3xl animate-pulse" style={{ animationDelay: '1s' }}></div>
        </div>

        <div className="relative h-full flex flex-col items-center justify-center px-4 sm:px-6 md:px-8 text-white">
          {slide.showLogo && (
            <div className="mb-6 md:mb-8 animate-fade-in">
              <div className="flex items-center gap-3 md:gap-4 bg-white/10 backdrop-blur-lg border-2 border-white/30 rounded-2xl md:rounded-3xl px-4 md:px-8 py-4 md:py-6">
                <div className="w-12 md:w-20 h-12 md:h-20 bg-white rounded-xl md:rounded-2xl flex items-center justify-center shadow-2xl">
                  <BookOpen className="w-6 md:w-10 h-6 md:h-10 text-indigo-600" />
                </div>
                <div>
                  <div className="text-3xl md:text-5xl font-black text-white leading-none tracking-tight">ÉLITE</div>
                  <div className="text-xs md:text-lg font-semibold text-white/90 tracking-widest">TUTORAT</div>
                </div>
              </div>
            </div>
          )}

          {!slide.showLogo && !slide.showThankYou && (
            <div className="text-5xl md:text-8xl mb-6 md:mb-8 animate-bounce">{slide.icon}</div>
          )}

          {slide.showThankYou && (
            <div className="text-7xl md:text-9xl mb-6 md:mb-8 animate-bounce">{slide.icon}</div>
          )}

          <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-7xl font-black mb-4 md:mb-6 text-center animate-fade-in px-2">
            {getText(slide.title)}
          </h1>

          <p className="text-lg sm:text-xl md:text-2xl lg:text-3xl text-white/90 mb-8 md:mb-12 text-center max-w-4xl animate-fade-in px-2" style={{ animationDelay: '0.2s' }}>
            {getText(slide.subtitle)}
          </p>

          {slide.description && (
            <p className="text-sm sm:text-base md:text-lg text-white/80 mb-6 md:mb-8 text-center max-w-3xl animate-fade-in px-2" style={{ animationDelay: '0.3s' }}>
              {getText(slide.description)}
            </p>
          )}

          {slide.isVideo ? (
            <div className="animate-fade-in" style={{ animationDelay: '0.4s' }}>
              <button
                onClick={() => setShowVideo(true)}
                className="group relative bg-white/20 backdrop-blur-lg border-2 border-white/30 px-6 md:px-12 py-4 md:py-6 rounded-xl md:rounded-2xl hover:bg-white/30 transition-all duration-300 flex items-center gap-3 md:gap-4"
              >
                <Play size={32} className="md:w-12 md:h-12 text-white group-hover:scale-110 transition-transform" />
                <span className="text-lg md:text-2xl font-bold">{language === 'fr' ? 'Voir la Démo' : 'شاهد العرض'}</span>
              </button>
            </div>
          ) : slide.isGallery ? (
            <div className="grid grid-cols-2 md:grid-cols-3 gap-3 md:gap-4 max-w-6xl w-full animate-fade-in px-2" style={{ animationDelay: '0.4s' }}>
              {galleryImages.map((img, index) => (
                <div
                  key={img.id}
                  onClick={() => setSelectedImage(img)}
                  className="group relative bg-white/10 backdrop-blur-lg border-2 border-white/30 rounded-lg md:rounded-xl overflow-hidden cursor-pointer hover:scale-105 transition-all duration-300 aspect-video"
                  style={{ animationDelay: `${0.1 * index}s` }}
                >
                  <img 
                    src={img.src} 
                    alt={img.title}
                    className="w-full h-full object-cover"
                    onError={(e) => {
                      e.target.style.display = 'none';
                      e.target.parentElement.querySelector('.placeholder-icon').style.display = 'flex';
                    }}
                  />
                  <div className="placeholder-icon absolute inset-0 bg-gradient-to-br from-purple-500/50 to-pink-500/50 group-hover:opacity-75 transition-opacity hidden items-center justify-center">
                    <Image size={32} className="md:w-12 md:h-12 text-white opacity-50" />
                  </div>
                  <div className="absolute bottom-0 left-0 right-0 bg-black/60 backdrop-blur-sm p-2 md:p-3">
                    <p className="font-bold text-xs md:text-sm">{img.title}</p>
                    <p className="text-xs text-white/80 hidden md:block">{img.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          ) : slide.content ? (
            <div className="space-y-3 md:space-y-4 max-w-3xl w-full px-2">
              {getContent(slide.content).map((item, index) => (
                <div
                  key={index}
                  className="bg-white/10 backdrop-blur-lg border-2 border-white/30 px-4 md:px-8 py-3 md:py-4 rounded-lg md:rounded-xl text-sm sm:text-base md:text-xl font-medium animate-fade-in hover:bg-white/20 transition-all duration-300"
                  style={{ animationDelay: `${0.1 * index}s` }}
                >
                  {item}
                </div>
              ))}
            </div>
          ) : null}
        </div>
      </div>

      <div className="absolute bottom-4 md:bottom-8 left-0 right-0 flex items-center justify-center gap-2 md:gap-4 px-4">
        <button
          onClick={prevSlide}
          disabled={currentSlide === 0}
          className="bg-white/20 backdrop-blur-lg border-2 border-white/30 p-2 md:p-3 rounded-full hover:bg-white/30 transition-all disabled:opacity-30 disabled:cursor-not-allowed"
        >
          <ChevronLeft size={24} className="md:w-8 md:h-8 text-white" />
        </button>

        <div className="flex gap-1 md:gap-2 overflow-x-auto max-w-xs md:max-w-none">
          {slides.map((_, index) => (
            <button
              key={index}
              onClick={() => goToSlide(index)}
              className={`h-2 md:h-3 rounded-full transition-all duration-300 flex-shrink-0 ${
                currentSlide === index 
                  ? 'w-8 md:w-12 bg-white' 
                  : 'w-2 md:w-3 bg-white/40 hover:bg-white/60'
              }`}
            />
          ))}
        </div>

        <button
          onClick={nextSlide}
          disabled={currentSlide === slides.length - 1}
          className="bg-white/20 backdrop-blur-lg border-2 border-white/30 p-2 md:p-3 rounded-full hover:bg-white/30 transition-all disabled:opacity-30 disabled:cursor-not-allowed"
        >
          <ChevronRight size={24} className="md:w-8 md:h-8 text-white" />
        </button>
      </div>

      <div className="absolute top-4 md:top-8 right-4 md:right-8 flex items-center gap-3">
        <button
          onClick={() => setLanguage(language === 'fr' ? 'ar' : 'fr')}
          className="bg-white/20 backdrop-blur-lg border-2 border-white/30 px-4 md:px-6 py-2 md:py-3 rounded-full text-white font-bold text-sm md:text-lg hover:bg-white/30 transition-all"
        >
          {language === 'fr' ? 'العربية' : 'Français'}
        </button>
        <div className="bg-white/20 backdrop-blur-lg border-2 border-white/30 px-3 md:px-6 py-2 md:py-3 rounded-full text-white font-bold text-sm md:text-xl">
          {currentSlide + 1} / {slides.length}
        </div>
      </div>

      {showVideo && (
        <div className="fixed inset-0 bg-black/95 z-50 flex items-center justify-center p-4 md:p-8">
          <div className="relative w-full max-w-6xl">
            <button
              onClick={() => setShowVideo(false)}
              className="absolute -top-12 md:-top-16 right-0 bg-red-600 hover:bg-red-700 p-3 md:p-4 rounded-full transition-all shadow-2xl z-10"
            >
              <X size={28} className="md:w-10 md:h-10 text-white" strokeWidth={3} />
            </button>
            <div className="bg-black rounded-xl md:rounded-2xl overflow-hidden aspect-video shadow-2xl">
              <video
                controls
                autoPlay
                className="w-full h-full"
                src="/video/abdo-shon.mp4"
              >
                Votre navigateur ne supporte pas la vidéo.
              </video>
            </div>
            <p className="text-white text-center mt-4 text-sm md:text-base">
              {language === 'fr' ? 'Appuyez sur ESC ou cliquez sur ✕ pour fermer' : 'اضغط ESC أو انقر على ✕ للإغلاق'}
            </p>
          </div>
        </div>
      )}

      {selectedImage && (
        <div className="fixed inset-0 bg-black/95 z-50 flex items-center justify-center p-4 md:p-8">
          <div className="relative w-full max-w-6xl">
            <button
              onClick={() => setSelectedImage(null)}
              className="absolute -top-12 md:-top-16 right-0 bg-red-600 hover:bg-red-700 p-3 md:p-4 rounded-full transition-all shadow-2xl z-10"
            >
              <X size={28} className="md:w-10 md:h-10 text-white" strokeWidth={3} />
            </button>
            <div className="bg-gradient-to-br from-purple-600 to-pink-600 rounded-xl md:rounded-2xl p-4 md:p-8 shadow-2xl">
              <div className="bg-white/10 backdrop-blur-lg border-2 border-white/30 rounded-lg md:rounded-xl aspect-video flex items-center justify-center mb-4 overflow-hidden">
                <img 
                  src={selectedImage.src} 
                  alt={selectedImage.title}
                  className="w-full h-full object-cover"
                  onError={(e) => {
                    e.target.style.display = 'none';
                    e.target.nextSibling.style.display = 'flex';
                  }}
                />
                <div className="hidden w-full h-full items-center justify-center">
                  <Image size={80} className="md:w-32 md:h-32 text-white opacity-30" />
                </div>
              </div>
              <h3 className="text-xl md:text-3xl font-bold text-white mb-2">{selectedImage.title}</h3>
              <p className="text-base md:text-xl text-white/80">{selectedImage.desc}</p>
            </div>
            <p className="text-white text-center mt-4 text-sm md:text-base">
              {language === 'fr' ? 'Appuyez sur ESC ou cliquez sur ✕ pour fermer' : 'اضغط ESC أو انقر على ✕ للإغلاق'}
            </p>
          </div>
        </div>
      )}

      <div className="absolute top-4 md:top-8 left-4 md:left-8 bg-white/20 backdrop-blur-lg border-2 border-white/30 px-3 md:px-4 py-1 md:py-2 rounded-full text-white text-xs md:text-sm hidden sm:block">
        {language === 'fr' ? '← → naviguer | ESC fermer' : '→ ← للتنقل | ESC للإغلاق'}
      </div>

      <style>{`
        @keyframes fade-in {
          from {
            opacity: 0;
            transform: translateY(20px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
        .animate-fade-in {
          animation: fade-in 0.6s ease-out forwards;
          opacity: 0;
        }
        
        @media (max-width: 640px) {
          .animate-fade-in {
            animation-duration: 0.4s;
          }
        }
      `}</style>
    </div>
  );
};

export default PresentationSlides;